import { useQuery } from "@tanstack/vue-query";
import { notificationRepo } from "@/di/repositories";

export function useNotifications() {
  return useQuery({
    queryKey: ["notifications", "list"],
    queryFn: () => notificationRepo.getNotifications(),
  });
}
